<div class="nearby-site-sales">
    <ev-grid-table [gridModel]="displayTemplate">
        <ev-th>
            <ev-td area="estate-type-icon"></ev-td>

            @for(column of headers; track column.name) {
                @if(column?.isSortable) {
                    <ev-td
                    class="header-column"
                    [area]="column.prop"
                    (click)="updateSort(column.prop)"
                    [isSelectable]="true"
                    [textAlignment]="column.textAlignment ?? 'left'"
                    [selected]="sortConfig().sortOption.prop == column.prop">
                        {{column.name.toUpperCase()}}
                    </ev-td>
                } 
                @else {
                    <ev-td [area]="column.prop" [textAlignment]="column.textAlignment ?? 'left'">
                        {{column.name.toUpperCase()}}
                    </ev-td>
                }
            }
        </ev-th>
        
        @if (tableData()) {
            @for(rowData of tableData(); track $index) {
                <ev-tr class="ev-row" [hasRowContent]="false">
                    <ev-td 
                        area="estate-type-icon" 
                        column 
                        [title]="rowData.estateType">
                        <span class="column-data"><div class="estate-type" [ngClass]="rowData.estateType"></div></span>
                    </ev-td>
                    <ev-td 
                        area="publicRegistrationDate" 
                        header="Dato" 
                        column
                        title="Dato"
                        [fontBold]="sortConfig().sortOption.prop == 'publicRegistrationDate'">
                        <div class="column-data">{{rowData.publicRegistrationDate | date:'dd.MM.yyyy'}}</div>
                    </ev-td>
                    <ev-td 
                        area="concatenatedAddress" 
                        header="Adresse" 
                        column
                        title="Adresse"
                        [fontBold]="sortConfig().sortOption.prop == 'concatenatedAddress'">
                        <div class="column-data">
                            @if(rowData.unitId) {
                                <a target="_blank" [routerLink]="['/resolve/infopage']" [queryParams]="{unitID: rowData.unitId}">
                                    {{rowData.concatenatedAddress | defaultconvert}}
                                </a>
                            }
                            @else {
                                {{rowData.concatenatedAddress | defaultconvert}}
                            }
                        </div>
                    </ev-td>
                    <ev-td 
                        area="ownershipType" 
                        header="Tomtetype" 
                        column
                        title="Tomtetype"
                        [fontBold]="sortConfig().sortOption.prop == 'ownershipType'">
                        <div class="column-data">{{rowData.ownershipType | defaultconvert}}</div>
                    </ev-td>
                    <ev-td 
                        area="siteArea" 
                        header="Areal" 
                        column
                        title="Areal"
                        [fontBold]="sortConfig().sortOption.prop == 'siteArea'">
                        <div class="column-data">{{rowData.siteArea | thousandize | unit : " m²"}}</div>
                    </ev-td>
                    <ev-td 
                        area="squareMeterPrice" 
                        header="m²-pris" 
                        column
                        title="m²-pris"
                        [fontBold]="sortConfig().sortOption.prop == 'squareMeterPrice'">
                        <div class="column-data">{{rowData.squareMeterPrice | defaultconvert}}</div>
                    </ev-td>
                    <ev-td 
                        area="price" 
                        header="Pris"
                        column
                        title="Pris"
                        [fontBold]="sortConfig().sortOption.prop == 'price'">
                        <div class="column-data">{{rowData.price | thousandize | defaultconvert}}</div>
                    </ev-td>
                </ev-tr>
            }
        }
    </ev-grid-table>

    @if(originalData()?.length > rowsToShow) {
        <div class="show-more-button">
            <button (click)="onShowMore()">Vis flere</button>
        </div>
    }
</div>